import React from 'react'

const Close = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/close',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <path
      d='M10 8.727L4.273 3 3 4.273 8.727 10 3 15.727 4.273 17 10 11.273 15.727 17 17 15.727 11.273 10 17 4.273 15.727 3z'
      fill={primaryColor}
      fillRule='evenodd'
    />
  </svg>
)

export default Close
